<template>
  <template v-if="isLoading">
    <loading :isLoading="isLoading" :message="'処理中...'"></loading>
  </template>
  <template v-if="!isLoading">
    <p>休憩時間を<strong>0:00～2:00の間で</strong>入力してください。</p>
    <p class="notice">雇用契約上の休憩時間を取得できていない場合には、休憩未取得申請を行ってください</p>
    <time-picker class="picker" v-model="kyuukeiTimes" :minTime="{ hours: 0, minutes: 0, seconds: 0 }" :maxTime="{ hours: 2, minutes: 0, seconds: 0 }" :isClearable="false">
    </time-picker>

    <div class="buttons vertical">
      <div class="btn primary" v-on:click="sendKyuuskei()">休憩時間を登録</div>
      <div class="btn info" v-on:click="cancel()">休憩を取得していない</div>
      <div class="btn cancel" v-on:click="cancel()">あとで登録する</div>
    </div>
  </template>
</template>

<script lang="ts">
import { useDakoku } from '@/composable/dakoku/dakoku';
import { cloneDeep } from 'lodash';
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    koyouKeiyakuId: {
      type: Number,
      require: true,
      default: null
    },
    syuugyouBasyoId: {
      type: Number,
      require: true,
      default: null
    },
    targetDate: {
      type: Object as () => Date | null,
      require: true,
      default: null
    }
  },
  emits: {
    send(result: Boolean): Boolean {
      return result
    },
    cancel() {
      return true
    }
  },
  setup(props, context) {
    const { kyuukei, isLoading } = useDakoku()

    const kyuukeiTimes = ref('1:00:00')

    const sendKyuuskei = async () => {
      if (!props.targetDate) {
        return
      }

      let result:Boolean = true
      try {
        result = await kyuukei(props.targetDate, kyuukeiTimes.value, props.syuugyouBasyoId, props.koyouKeiyakuId, null);
      } catch (e) {
        console.error(e);
      }
      context.emit('send', result);
    }

    const cancel = () => {
      context.emit('cancel')
    }

    const canSend = () => {
      if (!props.targetDate || !props.syuugyouBasyoId) {
        return false
      }

      return true
    }

    return {
      kyuukeiTimes,
      sendKyuuskei,
      isLoading,
      cancel,
      canSend
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/kyuukei-input.scss';
</style>
